const Handlebars = require('handlebars')

const normaliseHref = (value) => {
    const raw = String(value || '').trim()
    if (!raw) return ''
    return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`
}

module.exports = function (primaryDomain, arg2, arg3, arg4, arg5) {
    const usingLegacySignature = arg5 && typeof arg5 === 'object'
    const previewDomain = usingLegacySignature ? arg2 : ''
    const hostingDomain = usingLegacySignature ? arg3 : arg2
    const label = usingLegacySignature ? arg4 : arg3
    const options = usingLegacySignature ? arg5 : arg4

    const labelValue = typeof label === 'string' ? label : ''
    const fallbackLabel = labelValue || primaryDomain || hostingDomain || previewDomain || ''
    const resolvedDomain = [primaryDomain, hostingDomain, previewDomain].find((value) => String(value || '').trim())

    if (!resolvedDomain) {
        return Handlebars.escapeExpression(fallbackLabel)
    }

    const href = normaliseHref(resolvedDomain)
    const text = Handlebars.escapeExpression(fallbackLabel)
    const attrs = [
        `href='${Handlebars.escapeExpression(href)}'`,
        "data-action=''"
    ]

    if (options?.hash?.target) {
        attrs.push(`target='${Handlebars.escapeExpression(options.hash.target)}'`)
    }

    return new Handlebars.SafeString(`<a ${attrs.join(' ')}>${text}</a>`)
}
